/*
  Заведённые судебные участки для поля «Судебный участок».

  Отдельный лёгкий метод сервера (`/court-sections/names`), а не полный
  справочник: тот считает покрытие портфеля перебором адресов всех счетов
  (строка 66 реестра компромиссов), и открытие карточки счёта стоило бы этого
  перебора.

  Право на список то же, что на справочник, - `build_documents`. У всех, кто
  видит блоки действий (юрист, руководитель, агент), оно есть; оператору
  коммуникаций процессуальные действия не положены, и запрос за него не
  делается вовсе - иначе экран получал бы отказ на ровном месте.

  Ошибка не глушится (правило 3 скилла `frontend`): она возвращается наружу и
  встаёт под полем. Список не пришёл - участок всё равно можно вписать руками,
  и человек должен понимать, почему выбирать не из чего.
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'

export default function useCourtSections(enabled) {
  const [sections, setSections] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled) return undefined

    // Ответ, пришедший после ухода со страницы, состояние уже не трогает.
    let alive = true
    api
      .courtSectionNames()
      .then((rows) => {
        if (alive) setSections(rows)
      })
      .catch((failure) => {
        if (alive) setError(failure)
      })
    return () => {
      alive = false
    }
  }, [enabled])

  return { sections, error }
}
